import classnames from 'classnames';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

const CSS = require('./BackDrop.less');

interface BackDropProps {
  backdropId: string;
  underNavbar: boolean;
}

class BackDrop extends PureComponent<BackDropProps> {
  portalElement: any = null;

  componentDidMount() {
    let p =
      this.props.backdropId && document.getElementById(this.props.backdropId);
    if (!p) {
      p = document.createElement('div');
      p.id = this.props.backdropId;
      document.body.appendChild(p);
    }
    this.portalElement = p;
    this.renderPortal();
  }

  componentDidUpdate() {
    this.renderPortal();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.portalElement);
    document.body.removeChild(this.portalElement);
  }

  renderPortal() {
    ReactDOM.render(
      <div
        className={classnames(CSS.BackDrop, {
          [CSS.BackDropUnderNavbar]: this.props.underNavbar,
        })}
      />,
      this.portalElement,
    );
  }

  render() {
    return null;
  }
}

export default BackDrop;
